export default class LoDopPO {
    key:string;
    name:string;
    intOrient:number;//1---纵(正)向打印，固定纸张；2---横向打印，固定纸张；3---纵(正)向打印，宽度固定，高度按打印内容的高度自适应；0(或其它)----打印方向由操作者自行选择或按打印机缺省设置；
    intPageWidth:number;
    intPageHeight:number;
    strPageName:string;//所选纸张类型名，字符型
    intTop:number;
    intLeft:number;
    intWidth:number;
    intHeight:number;
    strContent:string;
    intShapeType:number;
    intLineStyle:number;//线条类型，数字型，0--实线 1--破折线 2--点线 3--点划线 4--双点划线
    intLineWidth:number;
    intColor:string;
    varItemNameID:string;
    strStyleName:string;//打印风格名，风格名称及其含义如下：“FontName”：设定纯文本打印项的字体名称。“FontSize”：设定纯文本打印项的字体大小。“FontColor”：设定纯文本打印项的字体颜色。
    varStyleValue:string;//打印风格值，相关值如下
    strURL:string;
    codeType:string;//条码类型，字符型。目前支持的类型（条码规制）主要是一维条码，有如下几种：128A，128B，128C，EAN8，EAN13，EAN128A，EAN128B，EAN128C，Code39，39Extended，2_5interleaved，2_5industrial，2_5matrix，UPC_A，UPC_E0，UPC_E1，UPCsupp2，UPCsupp5，Code93，93Extended，MSI，PostNet，Codaba，QRCode。
    codeValue:string;//条码值。
    chartType:string;//图表类型代码，整数型，目前支持的图表类型有如下几种：0--折线图；1--柱状图；2--条形图；3--面积图；4--散点图；5--饼图；6--直线图；7--甘特图；8--箭头图；9--气泡图；10—几何图；
  }